(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["advanced-text"] && !Shopify.designMode) return;
  try {
    class AdvancedText extends HTMLElement {
    /** @type {IntersectionObserver | null} */
    #intersectionObserver = null;

    /** @type {MutationObserver | null} */
    #slideVisibilityObserver = null;

    /** @type {MutationObserver | null} */
    #slideshowTransitionObserver = null;

    /** @type {HTMLElement | null} */
    #slide = null;

    /** @type {HTMLElement | null} */
    #slideshow = null;

    /** @type {number | null} */
    #playTimeoutId = null;

    /** @type {boolean} */
    #hasPlayed = false;

    /** @type {boolean} */
    #isReplaying = false;

    /** @type {boolean} */
    #pendingPlay = false;

    /** @type {((event: Event) => void) | null} */
    #onSlideshowSelect = null;

    connectedCallback() {
      if (this.dataset.animation === 'none' || this.#prefersReducedMotion()) {
        this.classList.add('advanced-text--visible');
        return;
      }

      this.#slide = this.closest('slideshow-slide');
      this.#slideshow = this.closest('slideshow-component');

      if (this.#slide) {
        this.#bindSlideVisibility();
        this.#bindSlideshowTransition();
        this.#syncFromSlide();
      } else {
        this.#bindIntersectionObserver();
      }
    }

    disconnectedCallback() {
      this.#clearPlayTimeout();
      this.#intersectionObserver?.disconnect();
      this.#slideVisibilityObserver?.disconnect();
      this.#slideshowTransitionObserver?.disconnect();
      if (this.#slideshow && this.#onSlideshowSelect) {
        this.#slideshow.removeEventListener('slideshow:select', this.#onSlideshowSelect);
      }
      this.#intersectionObserver = null;
      this.#slideVisibilityObserver = null;
      this.#slideshowTransitionObserver = null;
      this.#onSlideshowSelect = null;
      this.#slide = null;
      this.#slideshow = null;
    }

    get #shouldRepeat() {
      return this.dataset.animationRepeat === 'true';
    }

    #prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    #clearPlayTimeout() {
      if (this.#playTimeoutId !== null) {
        window.clearTimeout(this.#playTimeoutId);
        this.#playTimeoutId = null;
      }
    }

    #bindSlideVisibility() {
      if (!this.#slide) return;

      this.#slideVisibilityObserver = new MutationObserver(() => {
        this.#syncFromSlide();
      });

      this.#slideVisibilityObserver.observe(this.#slide, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'hidden', 'reveal'],
      });
    }

    #bindSlideshowTransition() {
      if (!this.#slideshow) return;

      this.#onSlideshowSelect = (event) => {
        if (!this.#slide) return;

        if (event.detail?.slide === this.#slide) {
          this.#queuePlay();
        } else if (this.#shouldRepeat) {
          this.#reset();
        }
      };

      this.#slideshow.addEventListener('slideshow:select', this.#onSlideshowSelect);

      this.#slideshowTransitionObserver = new MutationObserver(() => {
        if (
          this.#pendingPlay &&
          !this.#slideshow?.hasAttribute('transitioning') &&
          !this.#slideshow?.hasAttribute('dragging')
        ) {
          this.#schedulePlayAfterSettle();
        }
      });

      this.#slideshowTransitionObserver.observe(this.#slideshow, {
        attributes: true,
        attributeFilter: ['transitioning', 'dragging'],
      });
    }

    #schedulePlayAfterSettle() {
      this.#clearPlayTimeout();
      this.#pendingPlay = false;

      // One frame after scroll settles keeps slide-left from fighting carousel motion.
      this.#playTimeoutId = window.setTimeout(() => {
        this.#playTimeoutId = null;
        this.#startPlay();
      }, 16);
    }

    #bindIntersectionObserver() {
      if (!window.IntersectionObserver) {
        this.#queuePlay();
        return;
      }

      this.#intersectionObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (!entry) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            this.#queuePlay();
            if (!this.#shouldRepeat) {
              this.#intersectionObserver?.unobserve(this);
            }
          } else if (this.#shouldRepeat) {
            this.#reset();
          }
        },
        { threshold: [0, 0.25] }
      );

      this.#intersectionObserver.observe(this);
    }

    #syncFromSlide() {
      if (!this.#slide) return;

      const isVisible =
        this.#slide.getAttribute('aria-hidden') !== 'true' && !this.#slide.hasAttribute('hidden');

      if (isVisible) {
        this.#queuePlay();
      } else if (this.#shouldRepeat) {
        this.#reset();
      } else if (this.#hasPlayed) {
        this.classList.add('advanced-text--visible');
      }
    }

    #queuePlay() {
      this.#clearPlayTimeout();

      if (!this.#slideshow) {
        this.#playTimeoutId = window.setTimeout(() => {
          this.#playTimeoutId = null;
          this.#startPlay();
        }, 0);
        return;
      }

      this.#pendingPlay = true;

      // aria-hidden flips before slideshow `transitioning` is set — wait two frames
      // so we don't start horizontal motion while the carousel is still scrolling.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!this.#pendingPlay) return;

          if (this.#slideshow?.hasAttribute('transitioning') || this.#slideshow?.hasAttribute('dragging')) {
            return;
          }

          this.#schedulePlayAfterSettle();
        });
      });
    }

    #startPlay() {
      if (this.#hasPlayed && !this.#shouldRepeat) {
        this.classList.add('advanced-text--visible');
        return;
      }

      if (this.#isReplaying) return;

      if (this.classList.contains('advanced-text--visible')) {
        this.#replay();
        return;
      }

      this.classList.add('advanced-text--visible');
      this.#hasPlayed = true;
    }

    #reset() {
      this.#clearPlayTimeout();
      this.#pendingPlay = false;
      this.classList.remove('advanced-text--visible', 'advanced-text--replay');
      this.#isReplaying = false;
    }

    #replay() {
      if (!this.#shouldRepeat) return;

      this.#isReplaying = true;
      this.classList.add('advanced-text--replay');
      this.classList.remove('advanced-text--visible');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('advanced-text--replay');
          this.classList.add('advanced-text--visible');
          this.#hasPlayed = true;
          this.#isReplaying = false;
        });
      });
    }
  }

  if (!customElements.get('advanced-text')) {
    customElements.define('advanced-text', AdvancedText);
  }
  } catch(e) { console.error(e); }
})();

})();
